// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleReaderIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M17.43 15.67q-.77 0-1.36.56c-.36.36-.56.84-.56 1.35s.2 1 .56 1.36c.75.74 1.96.74 2.71 0 .75-.75.75-1.96 0-2.7-.37-.38-.86-.57-1.35-.57m3.8 6.83q-.46 0-.8-.33l-.96-.96c-1.6.9-3.64.66-4.99-.68-1.62-1.63-1.62-4.27 0-5.89s4.27-1.62 5.89 0c1.35 1.35 1.58 3.4.69 4.98l.96.96c.44.44.44 1.15 0 1.6q-.35.32-.8.32M9.84 1.5c-2.93 0-5.3 2.41-5.3 5.38 0 2.98 2.37 5.38 5.3 5.38s5.3-2.4 5.3-5.38-2.37-5.38-5.3-5.38" />
      <path
        d="M11.26 13.78H7.2c-3 0-5.54 2.58-5.54 5.62 0 .57 0 1.24.1 1.81l.02.12c.04.21.26.41.58.41h6.43c.36 0 .68-.22.81-.55l2.5-6.2c.23-.58-.2-1.2-.83-1.2"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default RoleReaderIcon;
